import { change } from 'redux-form'
import {
  Input,
  InlineText,
  RequiredValidation,
  PositiveNumberValidation,
  PositiveMaximumNumberValidation,
} from '../common'
import {
  INCIDENT_REPORT_FORM_NAME,
  INCIDENT_REPORT_DIGITAL_FIELD_NAMES as DIGITAL_FIELDS,
  INCIDENT_REPORT_SHARED_FIELD_NAMES as SHARED_FIELDS,
} from '../../constants/IncidentReportConstants'

const IncidentReportDigitalIncidentFields = ({ currentValues, change }) => {
  const fieldsetStyles = {
    marginTop: 0,
  }
  const childControlStyles = {
    marginLeft: '26px',
  }
  return (
    <>
      <div className="row">
        <div className="col-sm-6 col-xs-12">
          <div style={{ marginBottom: '24px' }}>
            <fieldset style={fieldsetStyles}>
              <legend style={{ fontWeight: 'bold' }}>
                Student Technology Issue Before Testing Starts (Select all that apply)
              </legend>
              <Input
                type="checkbox"
                label="Device froze or crashed"
                name={DIGITAL_FIELDS.deviceFrozeOrCrashBeforeTestingInd.name}
                isRequired={DIGITAL_FIELDS.deviceFrozeOrCrashBeforeTestingInd.required}
              />
              <Input
                type="checkbox"
                label={<>Student device didn&#39;t meet requirements</>}
                name={DIGITAL_FIELDS.deviceDidNotMeetReqInd.name}
                isRequired={DIGITAL_FIELDS.deviceDidNotMeetReqInd.required}
              />
              <Input
                type="checkbox"
                label="Loaner device unavailable or not working"
                name={DIGITAL_FIELDS.loanerDeviceIssueInd.name}
                isRequired={DIGITAL_FIELDS.loanerDeviceIssueInd.required}
              />
              <Input
                type="checkbox"
                label={<>Bluebook was not installed on the student&#39;s device</>}
                name={DIGITAL_FIELDS.blueBookNotInstalledInd.name}
                isRequired={DIGITAL_FIELDS.blueBookNotInstalledInd.required}
              />
              <Input
                type="checkbox"
                label={<>Student couldn&#39;t open Bluebook</>}
                name={DIGITAL_FIELDS.couldNotOpenBlueBookInd.name}
                isRequired={DIGITAL_FIELDS.couldNotOpenBlueBookInd.required}
              />
              <Input
                type="checkbox"
                label={<>Student couldn&#39;t sign in</>}
                name={DIGITAL_FIELDS.couldNotSignInd.name}
                isRequired={DIGITAL_FIELDS.couldNotSignInd.required}
              />
              <Input
                type="checkbox"
                label={<>The exam was not available on the student&#39;s Bluebook homepage</>}
                name={DIGITAL_FIELDS.testNotAvailableInd.name}
                isRequired={DIGITAL_FIELDS.testNotAvailableInd.required}
              />
              <Input
                type="checkbox"
                label={<>Student couldn&#39;t start the exam after entering the start code</>}
                name={DIGITAL_FIELDS.couldNotStartAfterTheStartCodeInd.name}
                isRequired={DIGITAL_FIELDS.couldNotStartAfterTheStartCodeInd.required}
              />
              <Input
                type="checkbox"
                label="Other"
                name={DIGITAL_FIELDS.studentTechIssueBeforeTestingOther.name}
                isRequired={DIGITAL_FIELDS.studentTechIssueBeforeTestingOther.required}
              />
            </fieldset>
          </div>
          <div style={{ marginBottom: '24px' }}>
            <fieldset style={fieldsetStyles}>
              <legend style={{ fontWeight: 'bold' }}>
                Student Technology Issues During Testing (Select all that apply)
              </legend>
              <Input
                type="checkbox"
                label="Answer submission error"
                name={DIGITAL_FIELDS.answerNotSubmittedInd.name}
                isRequired={DIGITAL_FIELDS.answerNotSubmittedInd.required}
              />
              <Input
                type="checkbox"
                label="Battery died"
                name={DIGITAL_FIELDS.batteryDiedInd.name}
                isRequired={DIGITAL_FIELDS.batteryDiedInd.required}
              />
              <Input
                type="checkbox"
                label="Bluebook or exam closed unexpectedly"
                name={DIGITAL_FIELDS.examClosedInd.name}
                isRequired={DIGITAL_FIELDS.examClosedInd.required}
              />
              <Input
                type="checkbox"
                label="Device froze or crashed"
                name={DIGITAL_FIELDS.deviceFrozeOrCrashInd.name}
                isRequired={DIGITAL_FIELDS.deviceFrozeOrCrashInd.required}
              />
              <Input
                type="checkbox"
                label="Device swap issue"
                name={DIGITAL_FIELDS.deviceSwapIssueInd.name}
                isRequired={DIGITAL_FIELDS.deviceSwapIssueInd.required}
              />
              <Input
                type="checkbox"
                label="Exited full screen mode/minimized"
                name={DIGITAL_FIELDS.minimizedInd.name}
                isRequired={DIGITAL_FIELDS.minimizedInd.required}
              />
              <Input
                type="checkbox"
                label="Inaccurate timing"
                name={DIGITAL_FIELDS.inAccurateTimingInd.name}
                isRequired={DIGITAL_FIELDS.inAccurateTimingInd.required}
              />
              <Input
                type="checkbox"
                label="Exam content was missing or illegible"
                name={DIGITAL_FIELDS.contentDisplayIssueInd.name}
                isRequired={DIGITAL_FIELDS.contentDisplayIssueInd.required}
              />
              <Input
                type="checkbox"
                label={<>Embedded calculator, countdown clock, or other tools didn&#39;t work</>}
                name={DIGITAL_FIELDS.calculatorClockOrToolIssueInd.name}
                isRequired={DIGITAL_FIELDS.calculatorClockOrToolIssueInd.required}
              />
              <Input
                type="checkbox"
                label="Keyboard malfunction"
                name={DIGITAL_FIELDS.keyboardIssueInd.name}
                isRequired={DIGITAL_FIELDS.keyboardIssueInd.required}
              />
              <Input
                type="checkbox"
                label="Bluebook embedded text-to-speech issue"
                name={DIGITAL_FIELDS.textToSpeechIssueInd.name}
                isRequired={DIGITAL_FIELDS.textToSpeechIssueInd.required}
              />
              <Input
                type="checkbox"
                label="Allowed student to use an alternate connection"
                name={DIGITAL_FIELDS.altConnectionInd.name}
                isRequired={DIGITAL_FIELDS.altConnectionInd.required}
              />
              <Input
                type="checkbox"
                label="Non-embedded assistive technology issue"
                name={DIGITAL_FIELDS.assistiveTechIssueInd.name}
                isRequired={DIGITAL_FIELDS.assistiveTechIssueInd.required}
              />
              <Input
                type="checkbox"
                label="Other"
                name={DIGITAL_FIELDS.studentTechIssueDuringTestingOther.name}
                isRequired={DIGITAL_FIELDS.studentTechIssueDuringTestingOther.required}
              />
            </fieldset>
          </div>
        </div>
        <div className="col-sm-6 col-xs-12">
          <div style={{ marginBottom: '24px' }}>
            <fieldset style={fieldsetStyles}>
              <legend style={{ fontWeight: 'bold' }}>
                Test Day Toolkit problem (Select all that apply)
              </legend>
              <Input
                type="checkbox"
                label={<>Couldn&#39;t access Test Day Toolkit</>}
                name={DIGITAL_FIELDS.couldNotAccessTDTKInd.name}
                isRequired={DIGITAL_FIELDS.couldNotAccessTDTKInd.required}
              />
              <Input
                type="checkbox"
                label={<>Couldn&#39;t check students in</>}
                name={DIGITAL_FIELDS.studentCheckInIssueInd.name}
                isRequired={DIGITAL_FIELDS.studentCheckInIssueInd.required}
              />
              <Input
                type="checkbox"
                label="Displayed inaccurate student statuses"
                name={DIGITAL_FIELDS.inAccurateStudentStatusInd.name}
                isRequired={DIGITAL_FIELDS.inAccurateStudentStatusInd.required}
              />

              <Input
                type="checkbox"
                label="Staff device issue"
                name={DIGITAL_FIELDS.staffDeviceIssueInd.name}
                isRequired={DIGITAL_FIELDS.staffDeviceIssueInd.required}
              />
              <Input
                type="checkbox"
                label="Other"
                name={DIGITAL_FIELDS.testDayToolKitProblemOther.name}
                isRequired={DIGITAL_FIELDS.testDayToolKitProblemOther.required}
              />
            </fieldset>
          </div>
          <div style={{ marginBottom: '24px' }}>
            <fieldset style={fieldsetStyles}>
              <legend style={{ fontWeight: 'bold' }}>
                Internet Problem (Select all that apply)
              </legend>
              <Input
                type="checkbox"
                label={<>Device couldn&#39;t connect to the internet</>}
                name={DIGITAL_FIELDS.couldNotConnectInd.name}
                isRequired={DIGITAL_FIELDS.couldNotConnectInd.required}
              />
              <Input
                type="checkbox"
                label={<>Connection dropped and couldn&#39;t be reestablished</>}
                name={DIGITAL_FIELDS.connectionDroppedInd.name}
                isRequired={DIGITAL_FIELDS.connectionDroppedInd.required}
              />
              <Input
                type="checkbox"
                label="Network outage"
                name={DIGITAL_FIELDS.networkOutageInd.name}
                isRequired={DIGITAL_FIELDS.networkOutageInd.required}
              />
              <Input
                type="checkbox"
                label="Other internet issue"
                name={DIGITAL_FIELDS.internetProblemOther.name}
                isRequired={DIGITAL_FIELDS.internetProblemOther.required}
              />
            </fieldset>
          </div>
          <Input
            type="checkbox"
            label="Illness"
            name={SHARED_FIELDS.illnessInd.name}
            isRequired={SHARED_FIELDS.illnessInd.required}
          />
          <div style={{ marginBottom: '24px' }}>
            <fieldset style={fieldsetStyles}>
              <legend className="sr-only">Rule Violation (Select any that apply)</legend>
              <Input
                type="checkbox"
                label="Rule Violation (Select any that apply)"
                input={{
                  name: SHARED_FIELDS.misconductInd.name,
                  checked: currentValues[SHARED_FIELDS.misconductInd.name] ?? false,
                  onChange: e => {
                    const { checked } = e.target
                    change(INCIDENT_REPORT_FORM_NAME, SHARED_FIELDS.misconductInd.name, checked)
                    if (!checked) {
                      change(
                        INCIDENT_REPORT_FORM_NAME,
                        SHARED_FIELDS.studentDismissedInd.name,
                        false
                      )
                      change(
                        INCIDENT_REPORT_FORM_NAME,
                        SHARED_FIELDS.usedProhibitedDeviceInd.name,
                        false
                      )
                      change(
                        INCIDENT_REPORT_FORM_NAME,
                        SHARED_FIELDS.removeExamMaterialsInd.name,
                        false
                      )
                    }
                  },
                }}
                name={SHARED_FIELDS.misconductInd.name}
                isRequired={SHARED_FIELDS.misconductInd.required}
              />
              <Input
                type="checkbox"
                label="Student Dismissed"
                name={SHARED_FIELDS.studentDismissedInd.name}
                isRequired={SHARED_FIELDS.studentDismissedInd.required}
                disabled={!currentValues[SHARED_FIELDS.misconductInd.name]}
                style={childControlStyles}
              />
              <Input
                type="checkbox"
                label="Student Observed with a Prohibited Device"
                name={SHARED_FIELDS.usedProhibitedDeviceInd.name}
                isRequired={SHARED_FIELDS.usedProhibitedDeviceInd.required}
                disabled={!currentValues[SHARED_FIELDS.misconductInd.name]}
                style={childControlStyles}
              />
              <Input
                type="checkbox"
                label="Student Removed/Attempted to Remove Exam Materials"
                name={SHARED_FIELDS.removeExamMaterialsInd.name}
                isRequired={SHARED_FIELDS.removeExamMaterialsInd.required}
                disabled={!currentValues[SHARED_FIELDS.misconductInd.name]}
                style={{ ...childControlStyles, marginBottom: '24px' }}
              />
            </fieldset>
          </div>
          <InlineText
            name={SHARED_FIELDS.disturbanceMinutes.name}
            validate={
              currentValues[SHARED_FIELDS.disturbanceMinutesInd.name]
                ? [RequiredValidation, PositiveNumberValidation, PositiveMaximumNumberValidation]
                : null
            }
            label=""
            placeholder="Enter number of minutes of disturbance"
            controlInput={{
              type: 'checkbox',
              name: SHARED_FIELDS.disturbanceMinutesInd.name,
              label: 'Disturbance-Number of Minutes',
              input: {
                onChange: e => {
                  const { checked } = e.target
                  change(
                    INCIDENT_REPORT_FORM_NAME,
                    SHARED_FIELDS.disturbanceMinutesInd.name,
                    checked
                  )
                  if (!checked) {
                    change(INCIDENT_REPORT_FORM_NAME, SHARED_FIELDS.disturbanceMinutes.name, null)
                  } else {
                    setTimeout(
                      () => document.getElementById(SHARED_FIELDS.disturbanceMinutes.name).focus(),
                      50
                    )
                  }
                },
              },
            }}
            disabled={!currentValues[SHARED_FIELDS.disturbanceMinutesInd.name]}
            isRequired={currentValues[SHARED_FIELDS.disturbanceMinutesInd.name]}
            maxlength={4}
            withFlexbox={false}
            fullWidthError={true}
            textboxGroupStyles={childControlStyles}
          />
          <InlineText
            name={SHARED_FIELDS.interruptionMinutes.name}
            validate={
              currentValues[SHARED_FIELDS.interruptionMinutesInd.name]
                ? [RequiredValidation, PositiveNumberValidation, PositiveMaximumNumberValidation]
                : null
            }
            label=""
            placeholder="Enter number of minutes of interruption"
            controlInput={{
              type: 'checkbox',
              name: SHARED_FIELDS.interruptionMinutesInd.name,
              label: 'Interruption-Number of Minutes',
              input: {
                onChange: e => {
                  const { checked } = e.target
                  change(
                    INCIDENT_REPORT_FORM_NAME,
                    SHARED_FIELDS.interruptionMinutesInd.name,
                    checked
                  )
                  if (!checked) {
                    change(INCIDENT_REPORT_FORM_NAME, SHARED_FIELDS.interruptionMinutes.name, null)
                  } else {
                    setTimeout(
                      () => document.getElementById(SHARED_FIELDS.interruptionMinutes.name).focus(),
                      50
                    )
                  }
                },
              },
            }}
            disabled={!currentValues[SHARED_FIELDS.interruptionMinutesInd.name]}
            isRequired={currentValues[SHARED_FIELDS.interruptionMinutesInd.name]}
            maxlength={4}
            withFlexbox={false}
            fullWidthError={true}
            textboxGroupStyles={childControlStyles}
          />
          <Input
            type="checkbox"
            label="Other"
            name={SHARED_FIELDS.otherInd.name}
            isRequired={SHARED_FIELDS.otherInd.required}
          />
        </div>
      </div>
    </>
  )
}

export default connect(state => state, { change })(IncidentReportDigitalIncidentFields)
